export default {
  API_URL: " https://dev.photosmile.biz",
  X_API_KEY: "CZgQHjiNJR55xB2vS5c5K5VaOiKzUKZ373VVdmlh",
  API_ENDPOINT_PREFIX_ADMIN: "api/1",
  PAYMENT: {
    KURONEKO: {
      GATEPAY: "https://ptwebcollect.jp/test_gateway/settleSelectAction.gw",
      trader_code: "888889213",
      goods_name: "goods_name lecre.saeda",
      return_url: "https://dev.photosmile.biz/api/1/paymentstatus",
    },
  },
  BANNER_SCHEDULES: [
    {
      from: {
        month: 8,
        day: 2,
      },
      to: {
        month: 10,
        day: 31,
      },
      url: "/images/banners/top_banner.png",
    },

    {
      from: {
        month: 11,
        day: 1,
      },
      to: {
        month: 8,
        day: 1,
      },
      url: "/images/banners/2020_new_year_banner.jpg",
    },
  ],
};
